export default __webpack_public_path__ + "media/color/bal-b2741c6a.svg";